import { RootState } from '../../store';

export const selectLoggedIn = (state: RootState) => state.auth.accessToken;

export const selectIsLoading = (state: RootState) => state.auth.loading;

export const selectLoginError = (state: RootState) => state.auth.loginError;

export const selectMfaRequired = (state: RootState) => state.auth.mfaRequired;